import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { fdcRequest } from "../../../staff_directory/universe-fdc-sprint1/services/fdcApi";
import { getPublicAccount, PUBLIC_NAV_THEME_EVENT, readPublicNavTheme, savePublicNavTheme } from "./publicNavigationState";

export default function usePublicNavigation() {
  const account = useSelector(getPublicAccount, shallowEqual);
  const [theme, setTheme] = useState(readPublicNavTheme);
  const [unread, setUnread] = useState(null);
  const [i18nNotice, setI18nNotice] = useState("");

  useEffect(() => {
    const sync = (event) => setTheme(event.detail || readPublicNavTheme());
    const syncStorage = () => setTheme(readPublicNavTheme());
    window.addEventListener(PUBLIC_NAV_THEME_EVENT, sync);
    window.addEventListener("storage", syncStorage);
    return () => { window.removeEventListener(PUBLIC_NAV_THEME_EVENT, sync); window.removeEventListener("storage", syncStorage); };
  }, []);

  useEffect(() => {
    setUnread(null);
    if (account.type !== "staff" || account.role !== "FDC" || !account.staffId) return;
    let alive = true;
    const load = async () => {
      if (document.visibilityState === "hidden") return;
      try {
        const response = await fdcRequest(account.staffId, "notifications");
        const records = Array.isArray(response?.data) ? response.data : Array.isArray(response?.data?.notifications) ? response.data.notifications : null;
        if (alive) setUnread(records ? records.filter((item) => !item.readAt).length : null);
      } catch { if (alive) setUnread(null); }
    };
    load();
    window.addEventListener("focus", load);
    document.addEventListener("visibilitychange", load);
    const interval = window.setInterval(load, 120000);
    return () => { alive = false; window.clearInterval(interval); window.removeEventListener("focus", load); document.removeEventListener("visibilitychange", load); };
  }, [account.type, account.role, account.staffId]);

  const updateTheme = (value) => { savePublicNavTheme(value); setTheme(value); };
  return { account, theme, updateTheme, unread, i18nNotice, setI18nNotice };
}
